import React from 'react'
import Navbar from '../navbar/navbar'
import Contact from '../contact/contact'

const Contactpage = () => {
  return (
    <div>
      <Navbar/>
      <Contact/>
    </div>
  )
}

export default Contactpage
